// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {buildCityStateZip, buildPhoneNumber} from '../../../product/shared/services/product';
import Customer from '@deere/cps-it.warranty-model-factory/lib/customer';
import {FormattedMessage} from 'react-intl';

const CustomerDetails = props =>
    <div className='labeled-string'>
        <span className='data-label'>
            <FormattedMessage id='CUSTOMER'/>
        </span>
        {props.customer.id ?
            <div className='data-value'>
                <span>{props.customer.displayName}</span>
                <span>{buildPhoneNumber(props.customer.phone[0])}</span>
                <span>{buildCityStateZip(props.customer.physicalAddress)}</span>
            </div> :
        null}
    </div>;

CustomerDetails.displayName = 'CustomerDetails';
CustomerDetails.propTypes = {
    customer: PropTypes.instanceOf(Customer).isRequired
};

export default CustomerDetails;



// WEBPACK FOOTER //
// ./src/pip/pip-code/components/customer-details.js